<template>
  <!-- 광고 지면 (Footer 최상단) -->
  <div :class="$style.adSectionWrapper">
    <AdSection :adBanners="adBanners" @ad-click="goToAdLink" />
  </div>

  <div :class="$style.feedbackSection">
    <div :class="$style.feedbackPrompt">불편한 점이 있으세요?</div>
    <button :class="$style.feedbackButton" @click="sendFeedback">
      <img :class="$style.xIcon" src="@/assets/images/xlogowhite.png" alt="X" />
      링꾹라이브 DM 보내기
    </button>
  </div>
  <div :class="$style.footer">
    <!-- 피드백/액션 섹션 -->

    <!-- 네비게이션 링크 섹션 -->
    <div :class="$style.navigationSection">
      <a href="#" :class="$style.navLink" @click.prevent="showPrivacyModal">개인정보처리방침</a>
      <span :class="$style.separator">|</span>
      <a href="#" :class="$style.navLink" @click.prevent="showTermsModal">이용약관</a>
      <span :class="$style.separator">|</span>
      <a href="#" :class="$style.navLink" @click.prevent="sendFeedback">홍보 문의</a>
    </div>

    <!-- 회사 정보 섹션 -->
    <div :class="$style.companySection">
      <div :class="$style.companyInfo">
        <p>Copyright 2024 ⓒLinkook. All rights reserved.</p>
        <!-- <span>상호명 링꾹</span>
        <span>대표 이민경</span>
        <span>사업자등록번호 897-07-03002</span>
        <span>서울특별시 강서구 마곡중앙2로 15, 1층 103호</span>
        <span>문의전화 070-8019-3736</span>
        <span>통신판매업 신고번호 제 2026-서울강서-0767 호</span> -->
        <!--  <span>링꾹라이브는 판매자와 구매자가 만나는 공간을 제공하며, 실제 상품과 거래에 대한 책임은 판매 회원에게 있습니다.</span> -->
      </div>
    </div>
  </div>

  <!-- 개인정보처리방침 모달 -->
  <privacy-modal :is-visible="showPrivacy" @close="closePrivacyModal" />

  <!-- 이용약관 모달 -->
  <terms-modal :is-visible="showTerms" @close="closeTermsModal" />
</template>

<script>
import PrivacyModal from "@/components/modal/PrivacyModal.vue";
import TermsModal from "@/components/TermsModal.vue";
import AdSection from "@/components/AdSection.vue";
import { incrementBannerClickCount } from "@/utils/write/banner";
import { firestore, storage } from "/firebaseConfig";
import { ref, getDownloadURL } from "firebase/storage";
import { query, collection, where, getDocs } from "firebase/firestore";

export default {
  name: "LinkookLiveFooter",
  components: {
    PrivacyModal,
    TermsModal,
    AdSection,
  },
  data() {
    return {
      showPrivacy: false,
      showTerms: false,
      adBanners: [],
    };
  },
  created() {
    this.fetchAdBanners();
  },
  methods: {
    async fetchAdBanners() {
      try {
        // 1. lives 컬렉션에서 bannerOn이 true인 데이터 가져오기
        const livesQuery = query(collection(firestore, "lives"), where("bannerOn", "==", true));
        const livesSnapshot = await getDocs(livesQuery);

        const liveBannerData = await Promise.all(
          livesSnapshot.docs.map(async (doc) => {
            const data = doc.data();

            // 배너 이미지 URL 처리
            let bannerImgUrl = data.banner;
            if (!bannerImgUrl) {
              console.error("배너 이미지가 없습니다:", data.title);
              return null;
            }

            if (!bannerImgUrl.startsWith("http")) {
              try {
                const imageRef = ref(storage, `banner/${data.banner}`);
                bannerImgUrl = await getDownloadURL(imageRef);
              } catch (e) {
                console.error("배너 이미지 로드 실패:", e);
                return null;
              }
            }

            return {
              id: doc.id,
              source: "live", // 출처 표시
              title: data.title,
              img: bannerImgUrl,
              link: null, // 라이브 상세로 이동
              date: data.date,
              place: data.place,
              type: data.type,
              priority: data.priority || 0, // 우선순위
            };
          })
        );

        // 2. banners 컬렉션에서 active가 true이고 type이 "detail"인 데이터 가져오기
        const bannersQuery = query(
          collection(firestore, "banners"),
          where("active", "==", true),
          where("type", "==", "detail")
        );
        const bannersSnapshot = await getDocs(bannersQuery);

        const customBannerData = await Promise.all(
          bannersSnapshot.docs.map(async (doc) => {
            const data = doc.data();

            // 광고 기간 체크 (startDateTime과 endDateTime이 있는 경우)
            if (data.startDateTime || data.endDateTime) {
              const now = new Date();

              // 시작일시 체크
              if (data.startDateTime) {
                const startDate = new Date(data.startDateTime);
                if (now < startDate) {
                  // 아직 광고 시작 전
                  return null;
                }
              }

              // 종료일시 체크
              if (data.endDateTime) {
                const endDate = new Date(data.endDateTime);
                if (now > endDate) {
                  // 광고 기간 종료됨
                  return null;
                }
              }
            }

            // 배너 이미지 URL 처리
            let bannerImgUrl = data.img;
            if (!bannerImgUrl) {
              console.error("배너 이미지가 없습니다:", data.title);
              return null;
            }

            if (!bannerImgUrl.startsWith("http")) {
              try {
                const imageRef = ref(storage, `banner/${data.img}`);
                bannerImgUrl = await getDownloadURL(imageRef);
              } catch (e) {
                console.error("배너 이미지 로드 실패:", e);
                return null;
              }
            }

            return {
              id: doc.id,
              source: "custom", // 출처 표시
              title: data.title,
              img: bannerImgUrl,
              link: data.link || "",
              date: data.date || "",
              place: data.place || "",
              type: "site", // 커스텀 배너는 site 타입으로
              priority: data.priority || 0, // 우선순위
            };
          })
        );

        // 두 배너 목록 합치기 (null 값 제거)
        const allBanners = [...liveBannerData.filter(Boolean), ...customBannerData.filter(Boolean)];

        // 우선순위로 정렬 (priority가 높을수록 먼저 표시)
        allBanners.sort((a, b) => {
          const priorityA = a.priority || 0;
          const priorityB = b.priority || 0;
          return priorityB - priorityA;
        });

        this.adBanners = allBanners;
      } catch (error) {
        console.error("광고 배너 가져오기 실패:", error);
        this.adBanners = [];
      }
    },

    async goToAdLink(ad) {
      // 클릭 횟수 증가
      await this.incrementAdClickCount(ad);

      // 커스텀 배너(source: "custom")이고 링크가 있는 경우 외부 링크로 이동
      if (ad.source === "custom" && ad.link) {
        window.open(ad.link, "_blank");
      } else if (ad.source === "live") {
        // 라이브 배너인 경우 해당 라이브 상세 페이지로 이동
        this.$router.push({
          name: "LiveDetail",
          params: { slug: ad.slug || ad.id },
        });
      }
    },

    async incrementAdClickCount(ad) {
      try {
        await incrementBannerClickCount(ad);
      } catch (error) {
        console.error("광고 클릭 횟수 증가 오류:", error);
        // 클릭 횟수 증가 실패해도 사용자 경험에는 영향을 주지 않음
      }
    },

    sendFeedback() {
      window.open("https://x.com/linkook_live", "_blank");
    },
    showPrivacyModal() {
      this.showPrivacy = true;
    },
    closePrivacyModal() {
      this.showPrivacy = false;
    },
    showTermsModal() {
      this.showTerms = true;
    },
    closeTermsModal() {
      this.showTerms = false;
    },
  },
};
</script>

<style module>
.adSectionWrapper {
  width: 100%;
}

.footer {
  width: 100%;
  margin: auto;
  font-family: var(--font-nanum-r), sans-serif;
  background-color: #fafafa;
  padding: 25px 18px;
  color: #333;
}

/* 피드백 섹션 */
.feedbackSection {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  background-color: #dcf5ff;
  padding: 10px 18px;
  gap: 12px;
}

.feedbackPrompt {
  font-size: 12px;
  font-weight: 500;
  color: #555;
}

.feedbackButton {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #6f6f6f;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.feedbackButton:hover {
  background-color: #f070a3;
}

.xIcon {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}

/* 네비게이션 섹션 */
.navigationSection {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.navLink {
  color: #555;
  text-decoration: none;
  font-size: 11px;
  transition: color 0.2s;
}

.navLink:hover {
  color: #000;
}

.separator {
  color: #ccc;
  font-size: 11px;
}

.navigationSection .xIcon {
  margin-left: auto;
  filter: none;
  width: 16px;
  height: 16px;
}

/* 회사 정보 섹션 */
.companySection {
  font-size: 11px;
  color: #666;
  line-height: 1.6;
}

.companyInfo {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.companyInfo span {
  display: block;
}

/* ================================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일, 최대 1024px)
   - Small: ~ 480px
   ================================================ */

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .footer {
    padding: 20px 12px;
  }

  .feedbackSection {
    flex-direction: column;
    padding: 12px;
    gap: 10px;
    align-items: center;
  }

  .feedbackPrompt {
    font-size: 11px;
    text-align: center;
    width: 100%;
  }

  .feedbackButton {
    padding: 10px 14px;
    font-size: 11px;
    gap: 6px;
    border-radius: 6px;
    width: 100%;
    justify-content: center;
  }

  .xIcon {
    width: 12px;
    height: 12px;
  }

  .navigationSection {
    justify-content: center;
    gap: 10px;
    padding-bottom: 12px;
  }

  .navLink {
    font-size: 10px;
  }

  .separator {
    font-size: 10px;
  }

  .navigationSection .xIcon {
    width: 14px;
    height: 14px;
    margin-left: 0;
  }

  .companySection {
    font-size: 10px;
    text-align: center;
  }

  .companyInfo {
    font-size: 10px;
    gap: 4px;
    align-items: center;
  }

  .companyInfo span {
    text-align: center;
  }
}
</style>
